import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Layout, Menu, Drawer, Button, Row, Col } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import useIsMobile from "../../custom-hooks/useIsMobile";

const { Header } = Layout;

const PageHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState(location.pathname);
  const [visible, setVisible] = useState(false);
  const [isMobile] = useIsMobile();

  useEffect(() => {
    setSelectedKey(location.pathname);
  }, [location.pathname]);

  const itemsLeft = [
    { key: "/", label: "Home" },
    { key: "/gallery", label: "Gallery" },
    { key: "/claire", label: "Claire" },
  ];

  const itemsRight = [
    { key: "/charlie", label: "Charlie" },
    { key: "/about", label: "About" },
  ];

  const showDrawer = () => setVisible(true);
  const onClose = () => setVisible(false);

  return (
    <Header
      style={{
        backgroundColor: "#f9f7f4",
        padding: "8px",
        height: isMobile ? "80px" : "180px",
      }}
    >
      {!isMobile ? (
        <>
          <Row
            justify="center"
            style={{
              display: "flex",
              height: "100%",
              alignItems: "center",
            }}
          >
            <Col align="left" flex={1} style={{ paddingLeft: "24px" }}>
              <Menu
                theme="light"
                mode="horizontal"
                selectedKeys={[selectedKey]}
                items={itemsLeft}
                onClick={(e) => navigate(e.key)}
              />
            </Col>
            <Col
              className="logo"
              style={{
                left: "50%",
                position: "absolute",
                paddingTop: "16px",
                paddingBottom: "0px",
              }}
            >
              <img
                src="/hyopearl.svg"
                alt="logo"
                onClick={() => navigate("/")}
                style={{ height: "150px", cursor: "pointer" }}
              />
            </Col>
            <Col
              align="end"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingRight: "24px",
              }}
            >
              <Menu
                theme="light"
                mode="horizontal"
                selectedKeys={[selectedKey]}
                items={itemsRight}
                onClick={(e) => navigate(e.key)}
              />
            </Col>
          </Row>
        </>
      ) : (
        <>
          <Row justify="space-between">
            <Col>
              <img
                src="/hyopearl.png"
                alt="logo"
                onClick={() => navigate("/")}
                style={{ height: "60px", cursor: "pointer" }}
              />
            </Col>
            <Col>
              <Button
                type="text"
                icon={<MenuOutlined />}
                onClick={showDrawer}
              />
            </Col>
          </Row>
        </>
      )}
      <Drawer placement="right" onClose={onClose} open={visible}>
        <Menu
          theme="light"
          mode="vertical"
          selectedKeys={[selectedKey]}
          items={[...itemsLeft, ...itemsRight]}
          onClick={(e) => {
            navigate(e.key);
            onClose();
          }}
        />
      </Drawer>
    </Header>
  );
};

export default PageHeader;
